module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content relation-content"
  }, [_c('div', {
    staticClass: "row relation-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Bạn bè")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-md-4 col-linked"
  }, [_c('div', {
    staticClass: "card card-relation-total"
  }, [_c('div', {
    staticClass: "box-relation-total"
  }, [_vm._m(0), _c('div', {
    staticClass: "amount-relation"
  }, [_c('div', {
    staticClass: "cur-total"
  }, [_c('div', [_vm._v("Đã liên kết")]), _c('div', [_vm._v(_vm._s(_vm.formatNumber(_vm.linkedTotal)))])])])])])]), _c('div', {
    staticClass: "col-xs-4 col-md-4 col-link-waiting"
  }, [_c('div', {
    staticClass: "card card-relation-total"
  }, [_c('div', {
    staticClass: "box-relation-total"
  }, [_vm._m(1), _c('div', {
    staticClass: "amount-relation"
  }, [_c('div', {
    staticClass: "cur-total"
  }, [_c('div', [_vm._v("Chờ bạn xác nhận")]), _c('div', [_vm._v(_vm._s(_vm.formatNumber(_vm.linkWaiting)))])])])])])]), _c('div', {
    staticClass: "col-xs-4 col-md-4 col-link-question"
  }, [_c('div', {
    staticClass: "card card-relation-total"
  }, [_c('div', {
    staticClass: "box-relation-total"
  }, [_vm._m(2), _c('div', {
    staticClass: "amount-relation"
  }, [_c('div', {
    staticClass: "cur-total"
  }, [_c('div', [_vm._v("Đã gửi yêu cầu")]), _c('div', [_vm._v(_vm._s(_vm.formatNumber(_vm.linkQuestion)))])])])])])])])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "btn-relation-list"
  }, [_c('button', {
    staticClass: "btn btn-relation-add-request",
    on: {
      "click": _vm.onAddRelation
    }
  }, [_vm._v("Thêm liên kết")])])]), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-relation-action"
  }, [(!_vm.mobile) ? _c('div', {
    staticClass: "box-table-relation",
    on: {
      "&scroll": function($event) {
        return _vm.handleScroll($event)
      }
    }
  }, [_c('tableRelation', {
    attrs: {
      "data": _vm.relations,
      "columns": _vm.columns,
      "inlineFilter": true,
      "lstStatus": _vm.lstStatus,
      "lstType": _vm.lstType
    },
    on: {
      "onAccept": _vm.accept,
      "onRefuse": _vm.refuse,
      "onCancelLink": _vm.cancelLink,
      "onCancelRequest": _vm.cancelRequest,
      "onRemoveRequest": _vm.removeRequest,
      "onfilterbystatus": _vm.filterbystatus,
      "onfilterbytype": _vm.filterbytype,
      "onSendLink": _vm.sendLink
    }
  })], 1) : _c('div', {
    staticClass: "box-table-relation-kanban"
  }, [_c('div', {
    staticClass: "box-filter"
  }, [_vm._m(3), _c('div', {
    staticClass: "col-xs-8 text-left"
  }, [_c('select', {
    attrs: {
      "id": "type"
    },
    on: {
      "change": function($event) {
        return _vm.filterbytype($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Tất cả")]), _vm._l((_vm.lstType), function(o, i) {
    return _c('option', {
      domProps: {
        "value": o.key
      }
    }, [_vm._v(_vm._s(o.value))])
  })], 2)]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "box-filter filter-status"
  }, [_vm._m(4), _c('div', {
    staticClass: "col-xs-8"
  }, [_c('select', {
    attrs: {
      "id": "status"
    },
    on: {
      "change": function($event) {
        return _vm.filterbystatus($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Tất cả")]), _vm._l((_vm.lstStatus), function(o, i) {
    return _c('option', {
      domProps: {
        "value": o.key
      }
    }, [_vm._v(_vm._s(o.value))])
  })], 2)]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "box-list"
  }, _vm._l((_vm.relations), function(item, index) {
    return _c('div', {
      staticClass: "box-list-items"
    }, [_c('div', {
      staticClass: "fullname"
    }, [(item.user_id_request === _vm.$store.getters.user) ? _c('div', {
      staticClass: "img-avt"
    }, [_c('img', {
      attrs: {
        "src": item.userRequested.avatar !== null && item.userRequested.avatar || require("../../assets/images/faces/ic_AvatarDefault.svg")
      }
    })]) : (item.user_id_requested === _vm.$store.getters.user) ? _c('div', {
      staticClass: "img-avt"
    }, [_c('img', {
      attrs: {
        "src": item.userRequest.avatar !== null && item.userRequest.avatar || require("../../assets/images/faces/ic_AvatarDefault.svg")
      }
    })]) : _vm._e(), _c('span', [_vm._v(_vm._s(item.user_id_request === _vm.$store.getters.user ? item.userRequested.fullname : item.userRequest.fullname))])]), _c('div', {
      staticClass: "box-type"
    }, [_vm._m(5, true), _c('div', {
      staticClass: "col-xs-8 text-left"
    }, [_c('select', {
      attrs: {
        "id": "type"
      },
      on: {
        "change": function($event) {
          return _vm.onTypeChange($event)
        }
      }
    }, _vm._l((_vm.lstType), function(o, i) {
      return _c('option', {
        domProps: {
          "value": o.key,
          "selected": o.key === item.type
        }
      }, [_vm._v(_vm._s(o.value))])
    }), 0)]), _c('div', {
      staticClass: "clearfix"
    })]), _c('div', {
      staticClass: "box-status"
    }, [_vm._m(6, true), _c('div', {
      staticClass: "col-xs-8 text-left"
    }, [_c('span', [_vm._v(_vm._s(_vm.getStatus(item)))])]), _c('div', {
      staticClass: "clearfix"
    })]), (item.status === 1 && item.user_id_requested === _vm.$store.getters.user) ? _c('div', {
      staticClass: "box-accept-refuse"
    }, [_c('div', {
      staticClass: "box-action",
      on: {
        "click": function($event) {
          return _vm.refuse(item)
        }
      }
    }, [_vm._m(7, true), _c('span', [_vm._v("Từ chối")])]), _c('div', {
      staticClass: "box-action",
      on: {
        "click": function($event) {
          return _vm.accept(item)
        }
      }
    }, [_vm._m(8, true), _c('span', [_vm._v("Chấp nhận")])])]) : _vm._e(), (item.status === 1 && item.user_id_request === _vm.$store.getters.user) ? _c('div', {
      staticClass: "box-dot"
    }, [_c('div', {
      staticClass: "col-xs-10"
    }), _c('div', {
      staticClass: "col-xs-2",
      attrs: {
        "id": "action" + item.id
      }
    }, [_c('i', {
      staticClass: "material-icons text-gray",
      staticStyle: {
        "cursor": "pointer",
        "line-height": "0"
      }
    }, [_vm._v("more_horiz")]), _c('b-popover', {
      attrs: {
        "target": "action" + item.id,
        "triggers": "hover",
        "placement": "bottom"
      }
    }, [
      [_c('div', {
        staticStyle: {
          "width": "110px",
          "height": "40px",
          "background": "#E0E0E0 0% 0% no-repeat padding-box",
          "box-shadow": "0px 1px 0px #00000029",
          "opacity": "1"
        }
      }, [(item.status === 2) ? _c('div', {
        staticClass: "cancel-link",
        staticStyle: {
          "cursor": "pointer",
          "text-align": "center",
          "color": "#23180A",
          "padding-top": "8px",
          "font-size": "15px"
        },
        on: {
          "click": function($event) {
            return _vm.cancelLink(item)
          }
        }
      }, [_vm._v("Hủy kết bạn")]) : _vm._e(), (item.status === 1) ? _c('div', {
        staticClass: "cancel-request",
        staticStyle: {
          "cursor": "pointer",
          "text-align": "center",
          "color": "#23180A",
          "padding-top": "8px",
          "font-size": "15px"
        },
        on: {
          "click": function($event) {
            return _vm.cancelRequest(item)
          }
        }
      }, [_vm._v("Hủy yêu cầu")]) : _vm._e(), (item.status === 3) ? _c('div', {
        staticClass: "remove-request",
        staticStyle: {
          "cursor": "pointer",
          "text-align": "center",
          "color": "#23180A",
          "padding-top": "8px",
          "font-size": "15px"
        },
        on: {
          "click": function($event) {
            return _vm.removeRequest(item)
          }
        }
      }, [_vm._v("Xóa yêu cầu")]) : _vm._e()])]
    ], 2)], 1)]) : _vm._e(), (item.status !== 1) ? _c('div', {
      staticClass: "box-dot"
    }, [_c('div', {
      staticClass: "col-xs-10"
    }), _c('div', {
      staticClass: "col-xs-2",
      attrs: {
        "id": "action" + item.id
      }
    }, [_c('i', {
      staticClass: "material-icons text-gray",
      staticStyle: {
        "cursor": "pointer",
        "line-height": "0"
      }
    }, [_vm._v("more_horiz")]), _c('b-popover', {
      attrs: {
        "target": "action" + item.id,
        "triggers": "hover",
        "placement": "bottom"
      }
    }, [
      [_c('div', {
        staticStyle: {
          "width": "110px",
          "height": "40px",
          "background": "#E0E0E0 0% 0% no-repeat padding-box",
          "box-shadow": "0px 1px 0px #00000029",
          "opacity": "1"
        }
      }, [(item.status === 2) ? _c('div', {
        staticClass: "cancel-link",
        staticStyle: {
          "cursor": "pointer",
          "text-align": "center",
          "color": "#23180A",
          "padding-top": "8px",
          "font-size": "15px"
        },
        on: {
          "click": function($event) {
            return _vm.cancelLink(item)
          }
        }
      }, [_vm._v("Hủy kết bạn")]) : _vm._e(), (item.status === 1) ? _c('div', {
        staticClass: "cancel-request",
        staticStyle: {
          "cursor": "pointer",
          "text-align": "center",
          "color": "#23180A",
          "padding-top": "8px",
          "font-size": "15px"
        },
        on: {
          "click": function($event) {
            return _vm.cancelRequest(item)
          }
        }
      }, [_vm._v("Hủy yêu cầu")]) : _vm._e(), (item.status === 3) ? _c('div', {
        staticClass: "remove-request",
        staticStyle: {
          "cursor": "pointer",
          "text-align": "center",
          "color": "#23180A",
          "padding-top": "8px",
          "font-size": "15px"
        },
        on: {
          "click": function($event) {
            return _vm.removeRequest(item)
          }
        }
      }, [_vm._v("Xóa yêu cầu")]) : _vm._e()])]
    ], 2)], 1)]) : _vm._e()])
  }), 0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-relation"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_linked.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-relation"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_link_waiting.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-relation"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_link_question.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_c('span', [_vm._v("Quan hệ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_c('span', [_vm._v("Trạng thái")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', [_vm._v("Quan hệ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', [_vm._v("Trạng thái")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-item-refuse"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_clear.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-item-check"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_check.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-088ba84d","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Relation/index.vue
// module id = 1478
// module chunks = 0